import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import axios from "axios";
import axiosClient from "../api/axiosClient";
import { Input } from "postcss";
import { useProfile } from "../contexts/ProfileContext";
import { API_BASE_URL } from '../config/api';
import Alert from "./Alert";

const ToolsCaption = () => {
	const profile = useProfile()

	const [captionImage, setCaptionImage] = useState(null); 
	const [uuid, setUUID] = useState(null);
	const [captions, setCaptions] = useState([]);
	const [generating, setGenerating] = useState(false);

	const [uploading, setUploading] = useState(false);		
	const [functionError, setFunctionError] = useState("");
	const [functionSuccess, setFunctionSuccess] = useState("");
	
	const handleCopy = (text) => {
		navigator.clipboard.writeText(text)
		  .then(() => {
			setFunctionSuccess("Copied to clipboard!");
		  })
		  .catch(err => {
			console.error("Failed to copy text: ", err);
		  });
	  };
	  
	const handleFileChange = async (event) => {
	  if (event.target.files && event.target.files.length > 0) {
		const file = event.target.files[0];
		// Generate a temporary URL for the selected file
		
		const formData = new FormData();
		formData.append("image", file);

		try {
			console.log("Sending post request to upload image...");

		  const response = await axios.post("https://images.viralgpt.com/upload", formData, {
			headers: {
			  "Content-Type": "multipart/form-data",
			},
		  });
	
		  console.log("Server response:", response.data);
		  setUUID(response.data.uuid);
		  setCaptionImage(URL.createObjectURL(file));
		 
		} catch (e) {
		  
		  setFunctionError("An error occurred while uploading the image: " + e.response.data.error);
		}
	  }
	};


	const generateCaption = async () => {
		if (!captionImage) return;
	
		try {
		  const formData = {};
		  formData.image = uuid;
		  formData.age = profile?.socials?.[profile?.selectedProfile]?.ageRange || ""
		  formData.gender = profile?.socials?.[profile?.selectedProfile]?.genderTarget || ""
		  formData.country = profile?.socials?.[profile?.selectedProfile]?.countries || ""
		  formData.niche = profile?.socials?.[profile?.selectedProfile]?.interests || ""
		  formData.username = profile?.socials?.[profile?.selectedProfile]?.username || ""
		  setGenerating(true);
		  setCaptions([]);

		  setUploading(true);
		  const response = await axiosClient.post("https://api.viralgpt.com/tools/caption", formData, {
			headers: {
			  "Content-Type": "application/json",
			},
		  });
		  setUploading(false);
	
		  console.log("Server response:", response.data);
		  setGenerating(false);
		  setCaptions(response.data.reply);
		  setFunctionSuccess("Captions generated successfully.");
		} catch (e) {
		  setGenerating(false);
		  console.error("Upload error:", e);
		  setFunctionError("An error occurred while generating the caption: "  + e.response.data.error);
		}
	};


	const clearImage = () => {
		setCaptionImage('');
		document.getElementById("fileInput").value = "";
	};





  return (
	<>
		<div className="bg-white border  p-6">
              <h5>Caption Generator</h5>
              <p className="text-muted mb-0">Upload a photo and generate a caption that's guaranteed to go viral.</p>

			  <Alert 
                variant="danger" 
                message={functionError} 
                show={!!functionError} 
                onClose={() => setFunctionError("")} 
              />
              
              <Alert 
                variant="success" 
                message={functionSuccess} 
                show={!!functionSuccess} 
                onClose={() => setFunctionSuccess("")} 
              />

              {/* Slider for Likes */}
              <div className="mb-3">
				
			  <Form.Group controlId="captionValue" className="mb-3">
				{/* Image Placeholder / Preview */}
				
				<div className="caption-container   mt-4">
				<img className="preview-image"  src={captionImage} />
				<button className={captionImage ? "close-icon" : "d-none"} onClick={() => clearImage()} aria-label="Close">
					&times;
				</button>
				</div>
				<br></br>
				{/* Icon as the "Upload" trigger */}
				<div style={{ marginBottom: "1rem" }} className={captionImage ? "d-none" : "d-block"}>
					{/* Use label to trigger the hidden input */}
					<label htmlFor="fileInput" className="border p-3" style={{ cursor: "pointer" }}>
					<i
						className={`fas fa-image text-instagram ${uploading ? 'fa-spin' : ''}`}
						style={{ fontSize: "2rem" }}
						title="Click to upload an image"
					/>
					</label>
				</div>

				{/* Hidden file input */}
				<Form.Control
					id="fileInput"
					type="file"
					accept="image/*, image/heif, image/heic"
					onChange={handleFileChange}
					style={{ display: "none" }}
				/>

				{/* Action Button */}
				<div className="d-flex align-items-center">
					<Button
						variant="primary"
						className={!captionImage || generating ? "disabled bg-instagram" : "bg-instagram"}
						onClick={() => generateCaption()}
					>
						Generate Caption
					</Button>
					<Button
						variant="primary"
						className={captions.length == 0 ? "d-none bg-instagram" : "ms-2 bg-instagram"}
						onClick={() => generateCaption()}
					>
						<i className="fa fa-arrows-rotate text-white"/>
					</Button>
					<div style={{fontSize: "1.5rem"}} className={`ms-2 fa fa-circle-notch fa-spin text-instagram ${!generating ? "d-none" : ""}`}/>
				</div>

				</Form.Group>
				<div>
					{captions.map((caption, index) => (
						<div
						key={index}
						style={{
							display: "flex",
							alignItems: "center",  // Ensures vertical centering in flex container
							marginBottom: "1rem",  // Optional spacing between rows
						}}
						>
						<button
							onClick={() => handleCopy(caption)}
							style={{ marginRight: "1rem" }} // Space between button & text
						>
							<i className="fa fa-copy text-instagram"></i>
						</button>
						<p style={{ margin: 0 }}>{caption}</p> 
						</div>
					))}
				</div>


              </div>
            </div>
	</>
  );
};

export default ToolsCaption;
